// src/components/scan/ScanHistory/ScanHistoryMobile.tsx
import React from 'react';
import { Calendar, Clock, History } from 'lucide-react';
import type { ScanHistoryProps } from './ScanHistoryDesktop';

const formatDate = (s?: string) =>
  s
    ? new Intl.DateTimeFormat('es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(new Date(s))
    : '—';

const ScanHistoryMobile: React.FC<ScanHistoryProps> = ({ scanHistory, t }) => {
  if (!scanHistory) return null;

  return (
    <div className="bg-gray-900 p-4 rounded-xl shadow-lg border border-gray-700 mb-8 max-w-sm mx-auto">
      {/* Título */}
      <h2 className="text-center text-white text-lg font-bold mb-4 flex items-center justify-center gap-2 leading-tight">
        <History className="w-5 h-5 text-blue-500 shrink-0" />
        {t('scan.history_title')} {scanHistory.domain ?? ''}
      </h2>

      {/* Dos tarjetas en grid; si no caben, se apilan */}
      <div className="grid grid-cols-2 gap-3">
        {/* Último escaneo */}
        <div className="bg-gray-800 p-3 rounded-lg shadow-md flex flex-col items-center">
          <Calendar className="w-5 h-5 text-blue-500 mb-1" />
          <h3 className="text-sm font-semibold text-white text-center">
            {t('scan.lastScan')}
          </h3>
          <p className="text-gray-300 text-sm text-center">
            {formatDate(scanHistory.lastScanDate)}
          </p>
        </div>

        {/* Escaneos último año */}
        <div className="bg-gray-800 p-3 rounded-lg shadow-md flex flex-col items-center">
          <Clock className="w-5 h-5 text-blue-500 mb-1" />
          <h3 className="text-sm font-semibold text-white text-center">
            {t('scan.scansLastYear')}
          </h3>
          <p className="text-gray-300 text-sm text-center">
            {scanHistory.scansLastYear ?? '—'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ScanHistoryMobile;
